const projects = [
  {
    title: 'Rock, paper, scissors',
    description: "A simple game and a fun way to implement some ideas that I had.",
    tags: ['NextJs', 'React', 'CSS'],
    link: 'https://rock-paper-scissors-jh.netlify.app/',
    className: 'rps',
    bgi: 'linear-gradient(150deg, rgba(141, 188, 146, 0.2) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Most populated cities',
    description: "A reactive app that shows the most populated cities in Argentina on a map.",
    tags: ['React', 'Leaflet', 'Mapbox'],
    link: 'https://most-populated-cities-jh.netlify.app/',
    className: 'mpc',
    bgi: 'linear-gradient(150deg, rgba(46, 46, 46, 0.05) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Lets chat!',
    description: "A simple chat app made with React, Socket.IO and cool CSS gradients.",
    tags: ['React', 'Socket.IO'],
    link: 'https://lets-chat-jh.netlify.app/',
    className: 'lca',
    bgi: 'linear-gradient(150deg, rgba(0, 130, 145, 0.1) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Rick and Morty',
    description: "An app made with GraphQL to search Rick and Morty's characters.",
    tags: ['GraphQL', 'Apollo', 'React'],
    link: 'https://rickandmorty-jh.netlify.com/',
    className: 'ram',
    bgi: 'linear-gradient(150deg, rgba(150, 215, 215, 0.2) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'The Global Breath',
    description: "The challenge was to have it done ASAP in order to tackle the covid-19 globally.",
    tags: ['NextJs', 'Translations', 'SEO'],
    link: 'https://www.theglobalbreath.com/',
    className: 'unr',
    bgi: 'linear-gradient(150deg, rgba(92, 156, 214, 0.1) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Expense tracker',
    description: 'An expense tracker made with react context API.',
    tags: ['useContext', 'localStorage'],
    link: 'https://context-expense-tracker.netlify.com/',
    className: 'exp',
    bgi: 'linear-gradient(150deg, rgba(242, 243, 247, 0.4) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Agrofy news',
    description: 'One of the biggest challenges I had, migrating a news site to a new app made 100% with React.',
    tags: ['React', 'SEO', 'Accessibility'],
    link: 'https://news.agrofy.com.ar/',
    className: 'agr',
    bgi: 'linear-gradient(150deg, rgba(126, 198, 10, 0.08) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Tu menu online',
    description: "It's a personal project created to speed up the way food is ordered in restaurants.",
    tags: ['React', 'SVG', 'Figma'],
    link: 'https://tumenuonline.com/',
    className: 'tmo',
    bgi: 'linear-gradient(150deg, rgba(103, 84, 226, 0.08) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Mountains',
    description: 'A minimalist app that lists mountains images. I made it to learn about Gatsby and PWA.',
    tags: ['React', 'PWA', 'Gatsby'],
    link: 'https://mountains-hj.netlify.com/',
    className: 'mou',
    bgi: 'linear-gradient(150deg, rgba(19, 17, 23, 0.09) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Congress Members',
    description: 'An application that lists the congress members and offers you the possibility to filter and contac.t them',
    tags: ['React', 'Rest API'],
    link: 'https://congressmembers.netlify.com/',
    className: 'con',
    bgi: 'linear-gradient(150deg, rgba(223, 166, 18, 0.1) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Totallia',
    description: "Totallia was my first site as a freelance developer. I knew very little about Wordpress, but tha.t wasn't a barrier",
    tags: ['Wordpress', 'Freelance'],
    link: 'https://totallia.com/',
    className: 'tot',
    bgi: 'linear-gradient(150deg, rgba(251, 80, 94, 0.06) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }, {
    title: 'Aibild',
    description: "One of the biggest ecommerce I've ever done. I love the way it looks.",
    tags: ['Magento', 'Ecommerce'],
    link: 'https://aibild.com/',
    className: 'aib',
    bgi: 'linear-gradient(150deg, rgba(111, 189, 171, 0.1) 20%, rgba(90, 130, 21, 0.02) 100%)'
  }
]

export default projects